<template>
  <div class="container">
    <!-- 头部 -->
    <van-nav-bar
      fixed
      title="积分当钱花"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight" />
    <!-- 积分狂欢城 -->
    <div class="happy-city">
      <img src="../../assets/img/pointsasmoney/happyCity.png" alt />
    </div>
    <!-- 积分兑福利  -->
    <div class="points-to-benefits">
      <div class="box">
        <span class="ptb fy">积分兑福利</span>
        <span class="more fy" @click="moreClick">更多</span>
      </div>
    </div>
    <!-- 积分兑换福利列表 -->
    <!-- 改动后 -->
    <div class="goods">
      <div class="goods-list">
        <router-link
          :to="{ name: 'shop-product', params: { id: item.id } }"
          class="goods-list-item"
          v-for="(item, index) in goods"
          :key="index">
          <img :src="item.coverImg" alt />
          <div class="list-right">
            <div class="text fy">{{ item.title }}</div>
            <div class="price fy">市场价：{{ item.oldPriceStr }}</div>
            <van-button size="small">{{ item.scoreStr }}积分兑换</van-button>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 源码 -->
    <!-- <div class="goods">
      <div class="goods-list" v-for="(item, index) in goods" :key="index">
        <img :src="item.coverImg" alt />
        <div class="list-right">
          <div class="text">{{ item.title }}</div>
          <div class="price">市场价：{{ item.oldPriceStr }}</div>
          <van-button size="small">{{ item.scoreStr }}积分兑换</van-button>
        </div>
      </div>
    </div> -->

    <!-- 积分说明 -->
    <div class="caption">
      <span class="line"></span>
      <span class="txt fy">积分说明</span>
      <span class="line"></span>
    </div>
    <!-- 投资指定产品 -->
    <div class="invest">
      <div class="text-title fy">投资指定资产</div>
      <div class="text fy">
        当您投资带有“返积分”标签的资产，即可获得相应积分，奖励积分=投资金额*投资期限/365*{{
          scoreRate
        }}%（小数按四舍五入处理，精确到个位）。
      </div>
      <div class="text fy" style="margin-top: 10px">
        举例：投资“返积分”365天资产1万元，即可获得{{
          num
        }}积分，投资“返积分”187天资产1万元，即可获得{{ point }}积分。
      </div>
      <div class="text-ex fy">
        说明：奖励积分不和其他优惠活动同享，奖励积分在成功投资资产时即发放。
      </div>
      <!-- 赚取积分 -->
      <div class="footer">
        <van-button size="large" @click="getClick">赚取积分</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant"
import * as GoodsApi from "@/api/goods"
export default {
  data() {
    return {
      goods: [],
      scoreRate: "",
      point: "",
      num: ""
    }
  },
  methods: {
    getClick() {
      this.$router.push("/rebatepoints")
    },
    onClickLeft() {
      this.goableBack()
    },
    onClickRight() {
      // Toast('按钮');
    },
    moreClick() {
      this.$router.push("/pointsmall")
    }
  },
  beforeMount() {
    // 实物兑换
    GoodsApi.list({ pageNo: 1, pageSize: 4 })
      .then((data) => {
        this.goods = data.list
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })

    GoodsApi.getScoreRate()
      .then((data) => {
        this.scoreRate = data.scoreRate
        // 不保留两位小数
        let point = (((10000 * 187) / 365) * this.scoreRate) / 100
        point = point.toFixed()
        this.point = point

        let num = (((10000 * 365) / 365) * this.scoreRate) / 100
        num = num.toFixed()
        this.num = num
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #f3f4f6;
}
// 积分狂欢城
.happy-city {
  margin-top: 45px;
  img {
    width: 100%;
    height: 136px;
  }
}
// 积分兑福利
.points-to-benefits {
  margin: 14px 20px;
  .box {
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    text-align: center;
  }

  .ptb {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }
  .more {
    color: #a9a9a9;
    font-size: 12px;
  }
}
// 积分兑福利列表
.goods {
  margin: 14px;
  border-radius: 10px;

  .goods-list-item {
    display: flex;
    align-items: center;
    margin-bottom: 13px;
    padding: 0 29px;
    height: 160px;
    background-color: #ffffff;
    border-radius: 7px;

    img {
      width: 130px;
      height: 130px;
    }

    .list-right {
      margin-left: 28px;

      .text {
        color: #333333;
        height: 40px;
        font-size: 14px;
        font-weight: 700;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .price {
        font-size: 10px;
        margin-top: 10px;
        color: #7b7a7a;
        font-weight: 700;
        text-decoration: line-through;
      }

      button {
        width: 130px;
        height: 26px;
        margin-top: 16px;
        color: #ffffff;
        background-color: #fc6524;
        letter-spacing: 0.5px;
        border: none;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
          Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
      }
    }
  }
}
//积分说明
.caption {
  height: 53px;
  line-height: 53px;
  text-align: center;

  .line {
    width: 17px;
    display: inline-block;
    margin: 0 10px;
    border-top: 1px solid #898989;
  }
  .txt {
    font-size: 16px;
    color: #898989;
    vertical-align: -4px;
  }
}
// 投资指定产品
.invest {
  padding: 0 14px;
  .text-title {
    font-weight: 700;
    font-size: 14px;
    color: #333333;
  }
  .text {
    margin-top: 10px;
    font-size: 13px;
    color: #333333;
    // letter-spacing: 0.5px;
  }
  .text-ex {
    //Microsoft YaHei
    font-size: 13px;
    margin-top: 10px;
  }
}
// 赚取积分
.footer {
  button {
    height: 42px;
    color: #ffffff;
    margin-top: 30px;
    background-color: #fc6524;
  }
}
</style>
